import {破棄破損修正候補検索結果レコード型} from '@/type/destroy/records/modify/破棄破損修正候補検索結果レコード型';
import {破棄破損理由区分型} from '@/type/destroy/types/破棄破損理由区分型';
import moment from 'moment';

export interface 破棄破損修正候補編集レコード型 {
  確定対象: boolean;
  部署コード: string;
  破棄破損日: Date;
  破棄破損箱数: number;
  破棄破損バラ数: number;
  破棄破損理由: 破棄破損理由区分型;
  破棄破損部署コード: string;
  破棄破損コメント: string;
  元レコード: 破棄破損修正候補検索結果レコード型;
}

export function to破棄破損修正候補編集レコード型(部署コード: string, record: 破棄破損修正候補検索結果レコード型): 破棄破損修正候補編集レコード型 {
  return {
    確定対象: false,
    部署コード,
    破棄破損日: record.破棄破損日,
    破棄破損箱数: record.破棄破損箱数,
    破棄破損バラ数: record.破棄破損バラ数,
    破棄破損理由: record.破棄破損理由,
    破棄破損部署コード: record.破棄破損部署コード,
    破棄破損コメント: record.破棄破損コメント,
    元レコード: record,
  };
}

export function 修正されている(record: 破棄破損修正候補編集レコード型): boolean {
  if (!moment(record.破棄破損日).isSame(record.元レコード.破棄破損日, 'day')) return true;
  if (record.破棄破損箱数 !== record.元レコード.破棄破損箱数) return true;
  if (record.破棄破損バラ数 !== record.元レコード.破棄破損バラ数) return true;
  if (record.破棄破損理由 !== record.元レコード.破棄破損理由) return true;
  if (record.破棄破損部署コード !== record.元レコード.破棄破損部署コード) return true;
  if (record.破棄破損コメント !== record.元レコード.破棄破損コメント) return true;
  return false;
}
